import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
export interface StepCountProps {
    variant: "circular" | "text";
    currentStep: number;
    totalSteps: number;
}
export function StepCount(props: StepCountProps) {
    const { variant, currentStep, totalSteps } = props;
    switch (variant) {
        case "circular":
            return <CircularStepCount currentStep={currentStep} totalSteps={totalSteps}/>;
        case "text":
            return <TextStepCount currentStep={currentStep} totalSteps={totalSteps}/>;
    }
}
interface StepCountVariantProps {
    currentStep: number;
    totalSteps: number;
}
const circularStepCountStyles = css({
    display: "flex",
    alignItems: "center",
    gap: space[8],
    flex: "1 0 0",
});
function CircularStepCount(props: StepCountVariantProps) {
    const { currentStep, totalSteps } = props;
    const strokeWidth = 3;
    const circleWidth = 35;
    const radius = circleWidth / 2 - strokeWidth;
    const dashArray = radius * Math.PI * 2;
    const progressPercentage = Math.ceil((currentStep / totalSteps) * 100);
    const dashOffset = dashArray - (dashArray * progressPercentage) / 100;
    return (<div className={circularStepCountStyles}>
            <svg width={circleWidth} height={circleWidth} viewBox={`0 0 ${circleWidth} ${circleWidth}`}>
                <circle cx={circleWidth / 2} cy={circleWidth / 2} strokeWidth={`${strokeWidth}px`} r={radius} className={css({
            fill: themeTokens.color.icon.inverse,
        })}/>
                <circle cx={circleWidth / 2} cy={circleWidth / 2} strokeWidth={`${strokeWidth}px`} r={radius} className={css({
            fill: "none",
            stroke: themeTokens.color.progress.background.secondary,
        })}/>
                <circle cx={circleWidth / 2} cy={circleWidth / 2} strokeWidth={`${strokeWidth}px`} r={radius} transform={`rotate(-90 ${circleWidth / 2} ${circleWidth / 2})`} className={css({
            fill: "none",
            stroke: themeTokens.color.progress.background.primary,
            strokeDasharray: `${dashArray}`,
            strokeDashoffset: `${dashOffset}`,
            strokeLinecap: "round",
            strokeLinejoin: "round",
        })}/>
                <text x={"50%"} y={"50%"} dy={"0.3em"} textAnchor={"middle"} className={css({
            font: text.body.bold.xSmall,
            fill: themeTokens.color.progress.text.info,
        })}>
                    {props.currentStep}/{props.totalSteps}
                </text>
            </svg>
        </div>);
}
const textStepCountStyles = {
    container: css({
        display: "flex",
        alignItems: "center",
    }),
    text: css({
        font: text.body.regular.medium,
        color: themeTokens.color.text.secondary,
    }),
};
function TextStepCount(props: StepCountVariantProps) {
    const { currentStep, totalSteps } = props;
    return (<div className={textStepCountStyles.container}>
            <div className={textStepCountStyles.text}>
                {currentStep} of {totalSteps}
            </div>
        </div>);
}
